import { z } from 'zod';

// Day availability schema
export const dayAvailabilitySchema = z.object({
  enable: z.boolean(),
  startDateMorning: z.string().optional(),
  closeDateMorning: z.string().optional(),
  startingDateAfternoon: z.string().optional(),
  closeDateAfternoon: z.string().optional(),
});

// Delivery type enum matching backend
export const deliveryTypeEnum = z.enum(['store', 'home', 'both']);

// Create shop form validation schema
export const createShopSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100),
  manager: z.string().min(1, 'Manager name is required'),
  description: z.string().min(1, 'Description is required').max(2000),
  phoneNumber: z.string().min(1, 'Phone is required'),
  delivery: deliveryTypeEnum,
  address: z.string().min(1, 'Address is required'),
  city: z.string().min(1, 'City is required'),
  department: z.string().optional(),
  postalCode: z.string().optional(),
  countryIsoCode3: z.string().min(3, 'Country is required').max(3),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  tags: z.string().optional(),
  shippingRates: z.array(z.string()).min(1, 'At least one shipping rate is required'),
  monday: dayAvailabilitySchema,
  tuesday: dayAvailabilitySchema,
  wednesday: dayAvailabilitySchema,
  thursday: dayAvailabilitySchema,
  friday: dayAvailabilitySchema,
  saturday: dayAvailabilitySchema,
  sunday: dayAvailabilitySchema,
});

// Update shop form validation schema
export const updateShopSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100),
  manager: z.string().min(1, 'Manager name is required'),
  description: z.string().min(1, 'Description is required').max(2000),
  phoneNumber: z.string().min(1, 'Phone is required'),
  delivery: deliveryTypeEnum,
  address: z.string().min(1, 'Address is required'),
  city: z.string().min(1, 'City is required'),
  department: z.string().optional(),
  postalCode: z.string().optional(),
  countryIsoCode3: z.string().min(3, 'Country is required').max(3),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  tags: z.string().optional(),
  shippingRates: z.array(z.string()).optional(),
  monday: dayAvailabilitySchema,
  tuesday: dayAvailabilitySchema,
  wednesday: dayAvailabilitySchema,
  thursday: dayAvailabilitySchema,
  friday: dayAvailabilitySchema,
  saturday: dayAvailabilitySchema,
  sunday: dayAvailabilitySchema,
});

// Form data types inferred from schemas
export type CreateShopFormData = z.infer<typeof createShopSchema>;
export type UpdateShopFormData = z.infer<typeof updateShopSchema>;
export type DayAvailability = z.infer<typeof dayAvailabilitySchema>;
export type DeliveryType = z.infer<typeof deliveryTypeEnum>;
